module.exports = __webpack_public_path__ + "static/media/Brightly_ios_5.8027ac00.jpg";